export function updateSearchParam(
  searchParams: URLSearchParams,
  key: string,
  value: any
) {
  if (typeof value === "boolean") {
    searchParams.set(key, value.toString());
  } else if (value && (Array.isArray(value) ? value.length > 0 : true)) {
    searchParams.set(
      key,
      Array.isArray(value) ? JSON.stringify(value) : value.toString()
    );
  } else {
    searchParams.delete(key);
  }
}

export function extractArrayFromSearchParams<T>(
  searchParams: URLSearchParams,
  key: string
): T[] {
  const array = searchParams.get(key);
  if (!array) {
    return [];
  }

  try {
    return JSON.parse(array);
  } catch (error) {
    return [];
  }
}
